import React from "react"
import Heading from "../../common/Heading"
import "./hero.css"

const Hero = () => {
  return (
    <>
      <section className='hero'>
        <div className='container'>
          <Heading title='Build with Us, Where Vision Meets Reality ' subtitle='Get the best work done today. ' />

         
          
        </div>
      </section>
    </>
  )
}

export default Hero
